
export default function ReviewBadges() {
  const badges = [
    {
      platform: 'Google',
      rating: 4.9,
      totalReviews: 127,
      icon: 'fab fa-google',
      color: 'text-red-500',
      bgColor: 'bg-red-50',
      link: 'https://www.google.com/search?q=brushour+reviews',
    },
    {
      platform: 'Trustpilot',
      rating: 4.8,
      totalReviews: 94,
      icon: 'fas fa-star',
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      link: 'https://www.trustpilot.com',
    },
  ];

  const renderStars = (rating: number) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    return (
      <div className="flex items-center gap-1">
        {[...Array(fullStars)].map((_, i) => (
          <i key={`full-${i}`} className="fas fa-star text-amber-500 text-lg"></i>
        ))}
        {hasHalfStar && (
          <i className="fas fa-star-half-alt text-amber-500 text-lg"></i>
        )}
        {[...Array(emptyStars)].map((_, i) => (
          <i key={`empty-${i}`} className="far fa-star text-amber-500 text-lg"></i>
        ))}
      </div>
    );
  };

  return (
    <section className="py-12 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {badges.map((badge, index) => (
            <a
              key={index}
              href={badge.link}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 border border-beige-200 cursor-pointer group"
            >
              <div className="flex items-center justify-between mb-6">
                <div className={`w-14 h-14 ${badge.bgColor} rounded-full flex items-center justify-center`}>
                  <i className={`${badge.icon} ${badge.color} text-2xl`}></i>
                </div>
                <div className="text-right">
                  <div className="text-3xl font-bold text-slate-900 mb-1">
                    {badge.rating}
                  </div>
                  <div className="text-xs text-slate-500 font-medium">
                    out of 5
                  </div>
                </div>
              </div>

              <div className="mb-4">
                {renderStars(badge.rating)}
              </div>

              <div className="flex items-center justify-between">
                <div>
                  <div className="text-lg font-bold text-slate-900 mb-1">
                    {badge.platform}
                  </div>
                  <div className="text-sm text-slate-600">
                    Based on <strong>{badge.totalReviews}</strong> reviews
                  </div>
                </div>
                <i className="ri-arrow-right-line text-2xl text-slate-400 group-hover:text-amber-600 group-hover:translate-x-1 transition-all duration-300"></i>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <p className="text-sm text-slate-600">
            Trusted by hundreds of satisfied customers across Hertfordshire and surrounding areas
          </p>
        </div>
      </div>
    </section>
  );
}
